import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {UsersComponent} from './components/users/users.component';
import {UserEditComponent} from './components/user-edit/user-edit.component';
import {AuthService} from './services/auth/auth.service';
import {AuthHttp} from './services/auth/http/auth-http.service';
import {UserService} from './services/user/user.service';
import {RoleService} from './services/role/role.service';
import {CurrentUserService} from './services/current-user/current-user.service';
import {PermissionGuard} from './guards/permission/permission.guard';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RegionModule} from '../region/region.module';
import { ArchivedUsersComponent } from './components/archived-users/archived-users.component';
import { ArchivedUsersService } from './services/archived-users/archived-users.service';

@NgModule({
  declarations: [
    UsersComponent,
    UserEditComponent,
    ArchivedUsersComponent,
  ],
  imports: [
    MaterialModule,
    UtilitiesModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    RegionModule
  ],
  exports: [
    UsersComponent
  ],
  providers: [
    AuthService,
    AuthHttp,
    UserService,
    RoleService,
    CurrentUserService,
    PermissionGuard,
    ArchivedUsersService
  ]
})
export class UserModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/user.module.ts